import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

'use strict';

const Timeline = {
	init: function() {
		const headings = document.querySelectorAll('.js-time-line-nav');
		const nums = document.querySelectorAll('.js-time-line-slide');
		//const head = document.querySelector('.js-time-line-head');
		const numOfTransitions = headings.length;
		const singleDuration = 700;
		const totalDuration = singleDuration * numOfTransitions;
		if (headings.length && nums.length) {
			headings.forEach((heading, i) => {
				gsap.fromTo([nums[i]], {opacity: 0}, {
					opacity: 1,
					scrollTrigger: {
						trigger: heading,
						toggleActions: 'play reverse play reverse',
						//toggleClass: 'active-content',
						start: '+=' + `${singleDuration * i}s`,
						end: '+=' + `${singleDuration}s`
					},
				});
				gsap.to([heading], {
					scrollTrigger: {
						trigger: heading,
						toggleActions: 'play reverse play reverse',
						toggleClass: 'active',
						scrub: 0.1,
						start: '+=' + `${singleDuration * i}s`,
						end: '+=' + `${singleDuration}s`,
					},
				});
			});

			gsap.to('.js-time-line-head', {
				scrollTrigger: {
					pin: '.js-time-line-head',
					end: '+=' + `${totalDuration + 600}s`,
					pinSpacing: true,
				},
			});
		}
	}
};

export default Timeline;
